import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { FullCarDetailPage } from './pages/FullCarDetailPage';
import { CeramicCoatingPage } from './pages/CeramicCoatingPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
import { MobileDetailingPage } from './pages/MobileDetailingPage';
import { EngineBayDetailingPage } from './pages/EngineBayDetailingPage';
import { CityPage } from './pages/CityPage';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
      gtag('config', 'AW-349742034');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="682rygdekbl">
      <Routes data-id="element-1" data-mp="5gel8p3rovc">
        <Route path="/" element={<HomePage data-id="element-3" data-mp="2zl3azit8d249" />} data-id="element-2" data-mp="56qjqnmbrsa" />
        <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-5" data-mp="2zn69yscd25l4" />} data-id="element-4" data-mp="2zlli5ahfl0qy" />
        <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-7" data-mp="33mym1f0yqtv8" />} data-id="element-6" data-mp="33mf623uvifju" />
        <Route path="/services/full-car-detail" element={<FullCarDetailPage data-id="element-9" data-mp="38l06a3a4kz8a" />} data-id="element-8" data-mp="38lrrqla0dgku" />
        <Route path="/services/ceramic-coating" element={<CeramicCoatingPage data-id="element-11" data-mp="3dlw727z6k59h" />} data-id="element-10" data-mp="38o4fxg6d0n6c" />
        <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-13" data-mp="nwc2huqftzxb" />} data-id="element-12" data-mp="3dm60k5jfoujx" />
        <Route path="/services/mobile-detailing" element={<MobileDetailingPage data-id="element-15" data-mp="su45bjsmf6ga" />} data-id="element-14" data-mp="nvaq9mxor7e0" />
        <Route path="/services/engine-bay-detailing" element={<EngineBayDetailingPage data-id="element-17" data-mp="3685nh1tcguh" />} data-id="element-16" data-mp="stc7017n2umb" />
        <Route path="/ventura-county/:slug" element={<CityPage data-id="element-19" data-mp="38b7cycbvyf1" />} data-id="element-18" data-mp="356tf9929ob6" />
      </Routes>
    </BrowserRouter>;
}